import { axios } from '@/utils/request'

/**
 * 查询医院信息/备案
 *
 * @author liwei
 * @date 2022-05-11 15:37:34
 */
export function baOrganizationPage (parameter) {
  return axios({
    url: '/baOrganization/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 医院信息/备案列表
 *
 * @author liwei
 * @date 2022-05-11 15:37:34
 */
export function baOrganizationList (parameter) {
  return axios({
    url: '/baOrganization/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加医院信息/备案
 *
 * @author liwei
 * @date 2022-05-11 15:37:34
 */
export function baOrganizationAdd (parameter) {
  return axios({
    url: '/baOrganization/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑医院信息/备案
 *
 * @author liwei
 * @date 2022-05-11 15:37:34
 */
export function baOrganizationEdit (parameter) {
  return axios({
    url: '/baOrganization/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除医院信息/备案
 *
 * @author liwei
 * @date 2022-05-11 15:37:34
 */
export function baOrganizationDelete (parameter) {
  return axios({
    url: '/baOrganization/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出医院信息/备案
 *
 * @author liwei
 * @date 2022-05-11 15:37:34
 */
export function baOrganizationExport (parameter) {
  return axios({
    url: '/baOrganization/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
